import { DisplayMode } from '@flywire/internal-components/model';

import { ENDPOINTS } from '../../endpoints';

export type PaymentInstructionsUrlBuilderParams = {
  token: string;
  paymentReference: string;
  displayMode?: DisplayMode;
};

export const paymentInstructionsUrlBuilder = (
  params: PaymentInstructionsUrlBuilderParams
): string => {
  const { token, paymentReference, displayMode = 'full-screen' } = params;
  const base = ENDPOINTS.paymentInstructionsForm.replace(
    ':paymentReference',
    encodeURIComponent(paymentReference)
  );

  const url = `${base}?token=${encodeURIComponent(token)}&display_mode=${encodeURIComponent(displayMode)}`;

  return url;
};
